import { NextUIProvider } from "@nextui-org/react";
import React from "react";
import { Outlet } from "react-router-dom";
import Header from "../components/header";
import { useAuth } from "../contexts/auth-context";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export default function Root() {
  const [{ isAuthenticated, user, status }] = useAuth();

  return (
    <NextUIProvider>
      <ToastContainer
        position="bottom-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={true}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />
      <Header />
      <Outlet />
    </NextUIProvider>
  );
}
